
import { Vue, Component, Prop } from 'vue-property-decorator';
import * as XLSX from 'xlsx';

@Component
export default class ExcelExport extends Vue {
  @Prop() filteredItems!: any[];
  @Prop() dateFromForInput!: string | null;
  @Prop() dateToForInput!: string | null;

  // Генерация имени файла
  getExcelFileName(): string {
    const startYear = this.dateFromForInput ? new Date(this.dateFromForInput).getFullYear() : '2025';
    const endYear = this.dateToForInput ? new Date(this.dateToForInput).getFullYear() : '2027';
    return `Проектно_сметная_документация_${startYear}_${endYear}.xlsx`;
  }

  // Форматирование данных
  formatDataForExport(data: any[]) {
    return data.map((item, index) => ([
      index + 1, // Номер строки
      item.report_number || '',
      item.project || '',
      item.report_date || '',
      item.object_place || '',
      item.customer || '',
      item.planner || '',
      item.timelimit ?? 0,
      item.status || '',
      item.comment || '',
      item.url || '',
      item.object_category || '',
      item.input_report || '',
      item.contract_number || '',
      item.contract_amount ?? 0,
      item.amount_plan ?? 0,
    ]));
  }

  // Экспорт в Excel
  exportExcelReport() {
    if (!this.filteredItems?.length) {
      alert('Нет данных для экспорта!');
      return;
    }

    const fileName = this.getExcelFileName();
    const ws = XLSX.utils.aoa_to_sheet([
      [fileName],
    //   [
    //     '', 'report_number', 'project', 'report_date', 'object_place',
    //     'customer_bin + customer', 'planner_bin + planner', 'timelimit', 'status',
    //     'comment', 'url', 'object_category', 'input_report', 'contract_number',
    //     'contract_amount', 'amount_plan'
    //   ],
      [
        '№', 'Номер заключения', 'Наименование проекта', 'Дата заключения',
        'Место расположения объекта', 'Заказчик', 'Проектировщик', 'Срок',
        'Статус', 'Комментарий', 'URL', 'Категория объекта', 'Акт ввода',
        'Номер договора', 'Сумма по договору', 'Сумма по плану'
      ],
      ...this.formatDataForExport(this.filteredItems)
    ]);

    // Настройка ширины колонок
    ws['!cols'] = [
      { wch: 5 }, { wch: 15 }, { wch: 40 }, { wch: 15 },
      { wch: 20 }, { wch: 15 }, { wch: 30 }, { wch: 10 },
      { wch: 15 }, { wch: 50 }, { wch: 50 }, { wch: 20 },
      { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }
    ];

    // Настройка высоты строк: первая строка обычная, остальные длинные
    ws['!rows'] = [{ hpt: 25 }, { hpt: 20 }, { hpt: 20 }, ...Array(99).fill({ hpt: 40 })];

    // Установка выравнивания текста по центру и стилизация заголовков
    // Установка выравнивания текста по центру и стилизация заголовков
const range = XLSX.utils.decode_range(ws['!ref'] || 'A1:A1');
for (let R = range.s.r; R <= range.e.r; ++R) {
  for (let C = range.s.c; C <= range.e.c; ++C) {
    const cell_address = XLSX.utils.encode_cell({ r: R, c: C });
    if (!ws[cell_address]) continue;
    if (!ws[cell_address].s) ws[cell_address].s = {};
    ws[cell_address].s.alignment = { horizontal: 'center', vertical: 'center' };
    
    // Заголовки второго ряда будут красными
    if (R === 2) {
      ws[cell_address].s.font = { color: { rgb: 'FF0000' }, bold: true }; // Красный цвет и жирный шрифт
    }
    if (R === 0) {
      ws[cell_address].s.font = { bold: true, sz: 14 };
      ws[cell_address].s.alignment = { horizontal: 'center', vertical: 'center' };
    }
  }
}
    // Создание книги Excel
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Проектно-сметная документация');
    XLSX.writeFile(wb, fileName);
  }
}

  